export const LICENSE_CLASS = [
    {
        "field_id": 203,
        "list_option_id": 503,
        "list_value": "BSS",
        "invalid": "0"
    },
    {
        "field_id": 203,
        "list_option_id": 504,
        "list_value": "BT\u0110",
        "invalid": "0"
    },
    {
        "field_id": 203,
        "list_option_id": 505,
        "list_value": "C1",
        "invalid": "0"
    },
    {
        "field_id": 203,
        "list_option_id": 506,
        "list_value": "C",
        "invalid": "0"
    },
    {
        "field_id": 203,
        "list_option_id": 515,
        "list_value": "A1m",
        "invalid": "0"
    },
    {
        "field_id": 203,
        "list_option_id": 516,
        "list_value": "Am",
        "invalid": "0"
    }
]

export const LICENSE_GROUP = [
    {
        list_value: 'BSS',
        list_option_id: 15
    },
    {
        list_value: 'BTĐ',
        list_option_id: 16},
    {
        list_value: 'C1',
        list_option_id: 17
    },
    {
        list_value: 'C',
        list_option_id: 6
    },
    {
        list_value: 'B1',
        list_option_id: 3
    },
    {
        list_value: 'B2',
        list_option_id: 2
    },
    {
        list_value: 'B11',
        list_option_id: 5
    },
    {
        list_value: 'XE - DỰ BỊ',
        list_option_id: 19
    },
    // {
    //     list_value: 'A',
    //     list_option_id: 10
    // },
    // { list_value: 'A1',
    //     list_option_id: 9
    // },
]